export default __webpack_public_path__ + "static/snap-first-frame-236b01b181021e2f4335cfa2719187a6.png";